import * as io from 'socket.io-client';

// One shared Socket.IO connection for the whole app. Deployed backends proxy Socket.IO on the
// API base URL, so connect there rather than to the gateway's internal port.
export const socket = io.connect(import.meta.env.VITE_BASE_URL_BACKEND);
